module.exports = __webpack_public_path__ + "img/shield.70f6c2e2.svg";